export default __webpack_public_path__ + "static/media/P308.2.add55214.mp3";